import { useContext, useEffect, useState } from "react"
import { Form, Button, Input, InputNumber, Select } from "antd"
import { useHistory } from "react-router-dom"
import { ArrowLeftOutlined } from "@ant-design/icons"
import axios from "axios"
import { UserContext } from "../Context/UserContext"

const CreateProduct = () => {
    const history = useHistory()
    const [category, setCategory] = useState([])
    const [user] = useContext(UserContext)

    useEffect(()=>{
        const categories = async () => {
            const result = await axios.get("https://backend-sportyan.vercel.app/api/categories")
                .then((res) => {
                    return res.data
                })
                .catch((err) =>{
                    console.log(err)
                })
            setCategory(result)
        }

        categories()
    }, [])

    const HandleBack = () => {
        history.goBack()
    }

    const onFinish = (values) => {
        axios.post("https://backend-sportyan.vercel.app/api/products", {...values}, {headers: {"Authorization" : "Bearer "+ user.token}})
            .then(()=>{
                history.push("/table-product")
            })
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const handleChange = (value) => {
        console.log(`selected ${value}`);
    };

    const options = [];
    category.map(function(item){
        return options.push({
            label: item.name,
            value: item.id
        })
    })

    return(
        <>
            <Button type="danger" icon={<ArrowLeftOutlined />} size="large" style={{marginBottom: "40px"}} onClick={HandleBack}>
                Kembali
            </Button>
            <Form
                name="basic"
                labelCol={{
                    span: 4,
                }}
                wrapperCol={{
                    span: 16,
                }}
                initialValues={{
                    remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >

                <Form.Item
                    label="Nama Produk"
                    name="name"
                    rules={[
                    {
                        required: true,
                        message: 'Please input product name!',
                    },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Deskripsi"
                    name="description"
                    rules={[
                    {
                        required: true,
                        message: 'Please input product description!',
                    },
                    ]}
                >
                    <Input/>
                </Form.Item>

                <Form.Item
                    label="Gambar"
                    name="image"
                    rules={[
                    {
                        required: true,
                        message: 'Please input product image!',
                    },
                    {
                        type: 'url',
                        warningOnly: true,
                    }
                    ]}
                >
                    <Input/>
                </Form.Item>

                <Form.Item
                    label="Stok"
                    name="stock"
                    rules={[
                    {
                        required: true,
                        message: 'Please input product stock!',
                    },
                    ]}
                >
                    <InputNumber />
                </Form.Item>

                <Form.Item 
                    label="Harga"
                    name="price"
                    rules={[
                        {
                            required: true,
                            message: 'Please input product price!',
                        },
                    ]}
                >
                    <InputNumber prefix="Rp" style={{width: '100%'}} />
                </Form.Item>

                <Form.Item 
                    label="Kategori"
                    name="category_ids"
                    rules={[
                        {
                            required: true,
                            message: 'Please input product category!',
                        },
                    ]}
                >
                    <Select
                        mode="multiple"
                        style={{width: '100%'}}
                        onChange={handleChange}
                        placeholder="select categories"
                        options={options}
                         />
                </Form.Item>

                <Form.Item
                    wrapperCol={{
                    offset: 4,
                    span: 16,
                    }}
                >
                    <Button type="primary" htmlType="submit">
                    Submit
                    </Button>
                </Form.Item>
            </Form>

        </>
    )
}
export default CreateProduct